import { Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { AccountActions, LocalizationActions, LocalizationSelectors, ModulesSelectors, SosLoaderService } from '@serviceos-ng/core';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'serviceos-web-select-language',
    templateUrl: './select-language.component.html',
    styleUrls: ['./select-language.component.scss'],
})
export class SelectLanguageComponent implements OnInit, OnDestroy {

    @Select(LocalizationSelectors.getLanguages())
    languages$!: Observable<any>;

    @Select(ModulesSelectors.getModuleConfigText('auth'))
    moduleAuthTexts$!: Observable<any>;

    public expand = false;
    public choosenLanguage: any;
    public isLanguageFieldDirty = false;
    public currentLanguageFlagUrl = '';
    public choosenLanguageTitle = '';
    public showLocalLoader = false;
    
    public subscriptions: Subscription[] = [];

    public documentDirection = '';

    constructor(
        private store: Store,
        private loaderService: SosLoaderService
    ) {}

    ngOnInit(): void {

        this.store.select(LocalizationSelectors.getCurrentDirection()).subscribe(
            (currentDirection) => {
                if (currentDirection) {
                    this.documentDirection = currentDirection;
                }
            }
        )
        
        this.choosenLanguage = this.store.selectSnapshot(LocalizationSelectors.getSelectedLanguage());
        this.choosenLanguageTitle = this.getCurrentLanguageTitle(this.choosenLanguage);
        this.getCurrentLanguageFlag(this.choosenLanguage);
    }

    public selectLanguage(language) {
        this.isLanguageFieldDirty = true;
        this.choosenLanguage = language.code;
        this.getCurrentLanguageFlag(language.code);
        this.choosenLanguageTitle = this.getCurrentLanguageTitle(language.code);
    }

    public submitLanguage() {
        this.showLocalLoader = true;
        this.store
            .dispatch(new LocalizationActions.ChangeLanguage(this.choosenLanguage))
            .pipe(
                finalize(() => {
                    this.store.dispatch(new AccountActions.updateLanguage(this.choosenLanguage))
                        .pipe(
                            finalize(() => {
                                // this.showLocalLoader = false;
                                window.location.reload();
                            })
                        ).subscribe();

                })
            )
            .subscribe();
    }

    private getCurrentLanguageTitle(currentLanguage) {
        const availableLanguages = this.store.selectSnapshot(LocalizationSelectors.getLanguages()),
                currentLanguageItem = availableLanguages.filter((item) => item.code === currentLanguage);

        return currentLanguageItem.length && currentLanguageItem[0].title ? currentLanguageItem[0].title : '' ;
    }
    
    private getCurrentLanguageFlag(currentLanguage) {

        const availableLanguages = this.store.selectSnapshot(LocalizationSelectors.getLanguages()),
                currentLanguageItem = availableLanguages.filter((item) => item.code === currentLanguage);

        this.currentLanguageFlagUrl = currentLanguageItem.length && currentLanguageItem[0].icon_url ? currentLanguageItem[0].icon_url : '';
    }

    ngOnDestroy(): void {
    }


}
